
export const ianaTimezones = [
  {
    ianaCode: 'Africa/Accra',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Addis_Ababa',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Algiers',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Asmara',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Asmera',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Bamako',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Bangui',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Banjul',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Bissau',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Blantyre',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Brazzaville',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Bujumbura',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Cairo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Casablanca',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Ceuta',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Conakry',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Dakar',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Dar_es_Salaam',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Djibouti',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Douala',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/El_Aaiun',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Freetown',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Gaborone',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Harare',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Johannesburg',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Juba',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Kampala',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Khartoum',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Kigali',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Kinshasa',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Lagos',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Libreville',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Lome',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Luanda',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Lubumbashi',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Lusaka',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Malabo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Maputo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Maseru',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Mbabane',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Mogadishu',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Monrovia',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Nairobi',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Ndjamena',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Niamey',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Nouakchott',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Ouagadougou',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Porto-Novo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Sao_Tome',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Timbuktu',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Tripoli',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Tunis',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Africa/Windhoek',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Adak',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Anchorage',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Anguilla',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Antigua',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Araguaina',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Argentina/Buenos_Aires',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Argentina/Catamarca',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Argentina/ComodRivadavia',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Argentina/Cordoba',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Argentina/Jujuy',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Argentina/La_Rioja',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Argentina/Mendoza',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Argentina/Rio_Gallegos',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Argentina/Salta',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Argentina/San_Juan',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Argentina/San_Luis',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Argentina/Tucuman',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Argentina/Ushuaia',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Aruba',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Asuncion',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Atikokan',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Atka',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Bahia',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Bahia_Banderas',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Barbados',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Belem',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Belize',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Blanc-Sablon',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Boa_Vista',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Bogota',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Boise',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Buenos_Aires',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Cambridge_Bay',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Campo_Grande',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Cancun',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Caracas',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Catamarca',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Cayenne',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Cayman',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Chicago',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Chihuahua',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Ciudad_Juarez',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Coral_Harbour',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Cordoba',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Costa_Rica',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Creston',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Cuiaba',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Curacao',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Danmarkshavn',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Dawson',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Dawson_Creek',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Denver',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Detroit',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Dominica',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Edmonton',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Eirunepe',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/El_Salvador',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Ensenada',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Fort_Nelson',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Fort_Wayne',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Fortaleza',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Glace_Bay',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Godthab',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Goose_Bay',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Grand_Turk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Grenada',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Guadeloupe',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Guatemala',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Guayaquil',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Guyana',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Halifax',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Havana',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Hermosillo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Indiana/Indianapolis',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Indiana/Knox',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Indiana/Marengo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Indiana/Petersburg',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Indiana/Tell_City',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Indiana/Vevay',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Indiana/Vincennes',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Indiana/Winamac',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Indianapolis',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Inuvik',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Iqaluit',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Jamaica',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Jujuy',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Juneau',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Kentucky/Louisville',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Kentucky/Monticello',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Knox_IN',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Kralendijk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/La_Paz',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Lima',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Los_Angeles',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Louisville',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Lower_Princes',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Maceio',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Managua',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Manaus',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Marigot',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Martinique',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Matamoros',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Mazatlan',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Mendoza',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Menominee',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Merida',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Metlakatla',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Mexico_City',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Miquelon',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Moncton',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Monterrey',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Montevideo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Montreal',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Montserrat',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Nassau',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/New_York',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Nipigon',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Nome',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Noronha',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/North_Dakota/Beulah',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/North_Dakota/Center',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/North_Dakota/New_Salem',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Nuuk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Ojinaga',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Panama',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Pangnirtung',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Paramaribo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Phoenix',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Port-au-Prince',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Port_of_Spain',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Porto_Acre',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Porto_Velho',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Puerto_Rico',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Punta_Arenas',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Rainy_River',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Rankin_Inlet',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Recife',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Regina',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Resolute',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Rio_Branco',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Rosario',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Santa_Isabel',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Santarem',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Santiago',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Santo_Domingo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Sao_Paulo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Scoresbysund',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Shiprock',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Sitka',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/St_Barthelemy',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/St_Johns',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/St_Kitts',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/St_Lucia',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/St_Thomas',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/St_Vincent',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Swift_Current',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Tegucigalpa',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Thule',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Thunder_Bay',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Tijuana',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Toronto',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Tortola',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Vancouver',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Virgin',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Whitehorse',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Winnipeg',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Yakutat',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'America/Yellowknife',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Antarctica/Casey',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Antarctica/Davis',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Antarctica/DumontDUrville',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Antarctica/Macquarie',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Antarctica/Mawson',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Antarctica/McMurdo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Antarctica/Palmer',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Antarctica/Rothera',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Antarctica/South_Pole',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Antarctica/Syowa',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Antarctica/Troll',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Antarctica/Vostok',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Arctic/Longyearbyen',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Aden',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Almaty',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Amman',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Anadyr',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Aqtau',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Aqtobe',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Ashgabat',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Ashkhabad',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Atyrau',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Baghdad',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Bahrain',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Baku',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Bangkok',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Barnaul',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Beirut',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Bishkek',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Brunei',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Calcutta',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Chita',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Choibalsan',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Chongqing',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Chungking',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Colombo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Dacca',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Damascus',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Dhaka',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Dili',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Dubai',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Dushanbe',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Famagusta',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Gaza',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Harbin',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Hebron',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Ho_Chi_Minh',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Hong_Kong',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Hovd',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Irkutsk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Istanbul',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Jakarta',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Jayapura',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Jerusalem',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Kabul',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Kamchatka',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Karachi',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Kashgar',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Kathmandu',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Katmandu',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Khandyga',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Kolkata',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Krasnoyarsk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Kuala_Lumpur',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Kuching',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Kuwait',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Macao',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Macau',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Magadan',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Makassar',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Manila',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Muscat',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Nicosia',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Novokuznetsk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Novosibirsk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Omsk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Oral',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Phnom_Penh',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Pontianak',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Pyongyang',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Qatar',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Qostanay',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Qyzylorda',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Rangoon',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Riyadh',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Saigon',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Sakhalin',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Samarkand',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Seoul',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Shanghai',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Singapore',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Srednekolymsk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Taipei',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Tashkent',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Tbilisi',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Tehran',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Tel_Aviv',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Thimbu',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Thimphu',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Tokyo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Tomsk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Ujung_Pandang',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Ulaanbaatar',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Ulan_Bator',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Urumqi',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Ust-Nera',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Vientiane',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Vladivostok',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Yakutsk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Yangon',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Yekaterinburg',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Asia/Yerevan',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Atlantic/Azores',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Atlantic/Bermuda',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Atlantic/Canary',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Atlantic/Cape_Verde',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Atlantic/Faeroe',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Atlantic/Faroe',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Atlantic/Jan_Mayen',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Atlantic/Madeira',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Atlantic/Reykjavik',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Atlantic/South_Georgia',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Atlantic/St_Helena',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Atlantic/Stanley',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/ACT',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Adelaide',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Brisbane',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Broken_Hill',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Canberra',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Currie',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Darwin',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Eucla',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Hobart',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/LHI',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Lindeman',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Lord_Howe',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Melbourne',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/NSW',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/North',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Perth',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Queensland',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/South',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Sydney',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Tasmania',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Victoria',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/West',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Australia/Yancowinna',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Brazil/Acre',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Brazil/DeNoronha',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Brazil/East',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Brazil/West',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'CET',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'CST6CDT',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Canada/Atlantic',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Canada/Central',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Canada/Eastern',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Canada/Mountain',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Canada/Newfoundland',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Canada/Pacific',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Canada/Saskatchewan',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Canada/Yukon',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Chile/Continental',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Chile/EasterIsland',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Cuba',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'EET',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'EST',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'EST5EDT',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Egypt',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Eire',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT+0',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT+1',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT+10',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT+11',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT+12',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT+2',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT+3',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT+4',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT+5',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT+6',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT+7',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT+8',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT+9',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-0',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-1',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-10',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-11',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-12',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-13',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-14',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-2',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-3',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-4',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-5',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-6',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-7',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-8',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT-9',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/GMT0',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/Greenwich',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/UCT',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/UTC',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/Universal',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Etc/Zulu',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Amsterdam',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Andorra',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Astrakhan',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Athens',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Belfast',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Belgrade',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Berlin',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Bratislava',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Brussels',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Bucharest',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Budapest',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Busingen',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Chisinau',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Copenhagen',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Dublin',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Gibraltar',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Guernsey',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Helsinki',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Isle_of_Man',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Istanbul',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Jersey',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Kaliningrad',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Kiev',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Kirov',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Kyiv',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Lisbon',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Ljubljana',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/London',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Luxembourg',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Madrid',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Malta',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Mariehamn',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Minsk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Monaco',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Moscow',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Nicosia',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Oslo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Paris',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Podgorica',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Prague',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Riga',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Rome',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Samara',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/San_Marino',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Sarajevo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Saratov',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Simferopol',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Skopje',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Sofia',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Stockholm',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Tallinn',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Tirane',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Tiraspol',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Ulyanovsk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Uzhgorod',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Vaduz',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Vatican',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Vienna',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Vilnius',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Volgograd',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Warsaw',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Zagreb',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Zaporozhye',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Europe/Zurich',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'GB',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'GB-Eire',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'GMT',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'GMT+0',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'GMT-0',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'GMT0',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Greenwich',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'HST',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Hongkong',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Iceland',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Indian/Antananarivo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Indian/Chagos',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Indian/Christmas',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Indian/Cocos',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Indian/Comoro',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Indian/Kerguelen',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Indian/Mahe',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Indian/Maldives',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Indian/Mauritius',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Indian/Mayotte',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Indian/Reunion',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Iran',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Israel',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Jamaica',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Japan',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Kwajalein',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Libya',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'MET',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'MST',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'MST7MDT',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Mexico/BajaNorte',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Mexico/BajaSur',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Mexico/General',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'NZ',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'NZ-CHAT',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Navajo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'PRC',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'PST8PDT',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Apia',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Auckland',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Bougainville',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Chatham',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Chuuk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Easter',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Efate',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Enderbury',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Fakaofo',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Fiji',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Funafuti',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Galapagos',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Gambier',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Guadalcanal',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Guam',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Honolulu',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Johnston',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Kanton',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Kiritimati',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Kosrae',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Kwajalein',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Majuro',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Marquesas',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Midway',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Nauru',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Niue',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Norfolk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Noumea',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Pago_Pago',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Palau',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Pitcairn',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Pohnpei',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Ponape',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Port_Moresby',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Rarotonga',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Saipan',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Samoa',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Tahiti',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Tarawa',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Tongatapu',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Truk',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Wake',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Wallis',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Pacific/Yap',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Poland',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Portugal',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'ROC',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'ROK',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Singapore',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Turkey',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'UCT',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'US/Alaska',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'US/Aleutian',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'US/Arizona',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'US/Central',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'US/East-Indiana',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'US/Eastern',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'US/Hawaii',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'US/Indiana-Starke',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'US/Michigan',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'US/Mountain',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'US/Pacific',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'US/Samoa',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'UTC',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Universal',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'W-SU',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'WET',
    id: '',
    timezoneName: ''
  },
  {
    ianaCode: 'Zulu',
    id: '',
    timezoneName: ''
  }
];
